import Pages from "layouts/Pages/Pages.jsx";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import NotRole from "layouts/notRole.js";

var indexRoutes = [
  { path: "/notRole", name: "No tienes permiso", component: NotRole },
/*  { path: "/clients", name: "Clientes", component: Client },
*/  { path: "/admin", name: "Administrador", component: Dashboard },
  { path: "/", name: "Inicio", component: Pages },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx